import { Resource as w, API as M } from "@coveo/platform-client";
import { shouldMockBatchAnswer as l } from "../ShouldMockBatchAnswer.js";
import { createMockBatchAnswerListResponse as d, createMockEvaluationCreationResponse as s, createMockBatchAnswerGetResponse as f } from "./BatchAnswerEvaluations.mocks.js";
const n = 2e3, r = 10, o = class o extends w {
  list(t, e) {
    return l(e == null ? void 0 : e.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i(
          d(t == null ? void 0 : t.filter)(
            (e == null ? void 0 : e.nbOfMockEntry) ?? r,
            t == null ? void 0 : t.page
          )
        );
      }, n);
    }) : this.api.get(this.buildPath(`${o.baseUrl}`, t));
  }
  create(t, e) {
    return l(e == null ? void 0 : e.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i(s());
      }, n);
    }) : this.api.post(o.baseUrl, t);
  }
  rename(t, e, i) {
    return l(i == null ? void 0 : i.isMocking) ? new Promise((h) => {
      setTimeout(() => {
        h(s());
      }, n);
    }) : this.api.put(
      `${o.baseUrl}/${t.evaluationId}/name`,
      e
    );
  }
  delete(t, e) {
    return l(e == null ? void 0 : e.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i();
      }, n);
    }) : this.api.delete(`${o.baseUrl}/${t.evaluationId}`);
  }
  get(t, e) {
    return l(e == null ? void 0 : e.isMocking) ? new Promise((i) => {
      setTimeout(() => {
        i(f());
      }, n);
    }) : this.api.get(`${o.baseUrl}/${t.evaluationId}`);
  }
};
o.baseUrl = `/rest/organizations/${M.orgPlaceholder}/answer/v1/evaluations`;
let p = o;
export {
  p as EvaluationResource
};
//# sourceMappingURL=BatchAnswerEvaluations.resource.js.map
